/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagListUpdateData } from '../../models/tag-list-update-data';

export interface DocumentUpdateChangedDocumentTagValues$Params {

/**
 * GUID of the document
 */
  documentId: string;
  
    /**
     * Tag values that should be updated. All other document tags stay unchanged
     */
    body: TagListUpdateData
}

export function documentUpdateChangedDocumentTagValues(http: HttpClient, rootUrl: string, params: DocumentUpdateChangedDocumentTagValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, documentUpdateChangedDocumentTagValues.PATH, 'put');
  if (params) {
    rb.path('documentId', params.documentId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

documentUpdateChangedDocumentTagValues.PATH = '/document/{documentId}/changed-tag-values';
